import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropdownDataService {

  constructor() { }

  fillGenderValues() {
    return [
      { key: 'Male', value: 'Male' }, { key: 'Female', value: 'Female' }, { key: 'Third-Gender', value: 'Third-Gender' }
    ];
  }

  fillResidentialStatusValues() {
    return [
      { key: 'Resident-Indian', value: 'Resident Indian' },
      { key: 'Non-Resident-Indian', value: 'Non Resident Indian' }
    ];
  }

  fillMartialStatusValues() {
    return [
      { key: 'Single', value: 'Single' }, { key: 'Married', value: 'Married' }, { key: 'Separated', value: 'Separated' },
      { key: 'Divorced', value: 'Divorced' }, { key: 'Widowed', value: 'Widowed' }
    ];
  }

  fillOccupationStatusValues() {
    return [
      { key: 'Salaried', value: 'Salaried' }, { key: 'Self-Employed', value: 'Self Employed' },
      { key: 'Unemployed', value: 'Unemployed' }
    ];
  }

  fillIncomeOccupationStatusValues() {
    return [
      { key: 'SALARIED', value: 'Salaried' }, { key: 'SELF_EMPLOYED_PROFESSIONAL', value: 'Self Employed Professional' },
      { key: 'SELF_EMPLOYED_NONPROFESSIONAL', value: 'Self Employed NonProfessional' }
    ];
  }


  fillRelationshipPrimaryValues(type: string) {
    if (type == "Organisation") {
      return [
        { key: 'Director', value: 'Director' }, { key: 'Guardian', value: 'Guardian' }, { key: 'MD', value: 'MD' },
        { key: 'Partner', value: 'Partner' }, { key: 'Trustee', value: 'Trustee' }, { key: 'Karta', value: 'Karta' }
      ];
    }

    return [
      { key: 'Friend', value: 'Friend' }, { key: 'Parent', value: 'Parent' }, { key: 'Sibling', value: 'Sibling' },
      { key: 'Spouse', value: 'Spouse' }
    ];
  }


  fillBusinessTypeValues() {
    return [
      { key: 'Government', value: 'Government' }, { key: 'Others', value: 'Others' },
      { key: 'Partnership Firm', value: 'Partnership Firm' }, { key: 'Public Limited Company', value: 'Public Limited Company' },
      { key: 'Private Limited Company', value: 'Private Limited Company' },
      { key: 'Society', value: 'Society' }, { key: 'Trust', value: 'Trust' }
    ]
  }

  fillLongevityValues() {
    return [
      { key: '1', value: '< 6 Months' }, { key: '2', value: '6 Months to 1 Year' },
      { key: '3', value: '1 year to 2 Year' }, { key: '4', value: '> 2 years' }
    ]
  }

  fillAbbToEmiValues() {
    return [
      { key: '1', value: 'Less than EMI' }, { key: '2', value: '1 to 2 times' },
      { key: '3', value: 'More than 2 times' }
    ]
  }

  fillBrands() {
    return [
      { key: 'Nissan', value: 'Nissan' }
    ];
  }

  fillModels() {
    return [
      { key: 'GO', value: 'Go' }
    ];
  }

  fillVariants() {
    return [
      { key: 'Repayment Variant 1', value: 'Repayment Variant 1' }
    ];
  }

}
